import Leaflet from "leaflet";
import React, {useEffect} from "react";
import {MapContainer, Marker, TileLayer, useMapEvents} from "react-leaflet";
import {Col, Container, Row} from "react-bootstrap";

import "./index.scss";

type props = {
  onChangeLatAndLng?: (lat: any, lng: any) => void;
  defaultLat?: any;
  defaultLng?: any;
  defaultLatArea?: any;
  defaultLngArea?: any;
};

const CustomLeaflet: React.FC<props> = ({
  onChangeLatAndLng,
  defaultLat = 36.92448,
  defaultLng = 50.64137,
  defaultLngArea,
  defaultLatArea,
}) => {
  /**
   *
   */
  const mapRef: any = React.createRef();
  const inServiceDriverIcon = new Leaflet.Icon({
    iconUrl: require("../../../assets/images/map-pointer.png"),
    iconRetinaUrl: require("../../../assets/images/map-pointer.png"),
    iconSize: [24, 24],
    iconAnchor: [12, 24],
    className: "icon-marker",
  });

  const MapEvents = () => {
    useMapEvents({
      click(event: Leaflet.LeafletMouseEvent) {
        onChangeLatAndLng && onChangeLatAndLng(event.latlng.lat, event.latlng.lng);
      },
    });
    return <></>;
  };
  /**
   *
   */

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setView([defaultLatArea || 36.92448, defaultLngArea || 50.641372]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLatArea, defaultLngArea]);

  return (
    <Container>
      <Row className="map-modal-container">
        <Col id="map-holder">
          <MapContainer
            ref={mapRef}
            center={[defaultLatArea || 36.92448, defaultLngArea || 50.641372]}
            zoom={12}
            scrollWheelZoom={true}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker key={"marker-location-123456789"} position={{lat: defaultLat, lng: defaultLng}} icon={inServiceDriverIcon}>
              {/* <Popup>
                                <p>text...</p>
                            </Popup> */}
            </Marker>
            <MapEvents />
          </MapContainer>
        </Col>
      </Row>
    </Container>
  );
};

export default CustomLeaflet;
